"use strict";
import Api from "../../api/api";
function isLtlReconcileEnabled(maybeCarrierInvoice) {
  const indexAuditSplitEnabled = !!Api.Account.currentSettings().index_audit_split_enabled;
  const isLtlReconcileEnabled2 = !!Api.Account.currentSettings().ltl_reconcile_enabled;
  const invoiceHasLtlSubmission = maybeCarrierInvoice == null ? void 0 : maybeCarrierInvoice.has_ltl_submission;
  return indexAuditSplitEnabled && isLtlReconcileEnabled2 && invoiceHasLtlSubmission;
}
export { isLtlReconcileEnabled };
